import {switchEventsPlugin} from '../alarms/plugin';

export default switchEventsPlugin;
